<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'BUSES.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'BUSES.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printCardsPdf()"
        [disabled]="exporting || (!selected.length && !filteredItems.length)"
      >
        <mat-icon>qr_code_2</mat-icon>
        {{ (exportingCards ? 'BUSES.CARDS_PDF_EXPORTING' : 'BUSES.PRINT_CARDS') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *appAccess="'buses:add'" (click)="onAdd()" [disabled]="exporting">
        <mat-icon>add</mat-icon>
        {{ 'BUSES.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="isError && !open">{{ errorMessage | translate }}</div>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input type="search" class="search-input" [placeholder]="'BUSES.SEARCH' | translate"
          [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
        <span class="selection-badge" *ngIf="selected.length">{{ selected.length }} {{ 'COMMON.SELECTED' | translate }}</span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">{{ 'COMMON.CLEAR' | translate }}</button>
        <ng-container *appAccess="'buses:edit'">
          <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1" (click)="onEdit()">{{ 'COMMON.EDIT' | translate }}</button>
        </ng-container>
        <ng-container *appAccess="'buses:delete'">
          <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length" (click)="onDeleteMany()">{{ 'COMMON.DELETE' | translate }}</button>
        </ng-container>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedItems.length; else emptyBuses">
        <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>{{ 'BUSES.NUMBER' | translate }}</th>
            <th>{{ 'COMMON.NAME' | translate }}</th>
            <th>{{ 'BUSES.DRIVER' | translate }}</th>
            <th>{{ 'BUSES.CAPACITY' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of paginatedItems"
            class="clickable"
            [class.selected]="isSelected(item)"
            (click)="openDetails(item)"
          >
            <td (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item, $event)" />
            </td>
            <td>{{ item.number }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.driverName || '—' }}</td>
            <td>{{ item.capacity || '—' }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyBuses><div class="empty-state">{{ 'BUSES.EMPTY' | translate }}</div></ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredItems.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">{{ 'COMMON.PREVIOUS' | translate }}</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">{{ 'COMMON.NEXT' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate: deleteModalParams }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">{{ 'COMMON.DELETE' | translate }}</button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ (mode === 'edit' ? 'BUSES.EDIT_TITLE' : 'BUSES.ADD_TITLE') | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form" class="form-grid">
        <div class="form-field"><label>{{ 'COMMON.NAME' | translate }}</label><input formControlName="name" /></div>
        <div class="form-field"><label>{{ 'BUSES.NUMBER' | translate }}</label><input formControlName="number" /></div>
        <div class="form-field"><label>{{ 'BUSES.PLATE' | translate }}</label><input formControlName="plateNumber" /></div>
        <div class="form-field"><label>{{ 'BUSES.CAPACITY' | translate }}</label><input type="number" formControlName="capacity" min="1" /></div>
        <div class="form-field"><label>{{ 'BUSES.DRIVER' | translate }}</label><input formControlName="driverName" /></div>
        <div class="form-field"><label>{{ 'BUSES.DRIVER_PHONE' | translate }}</label><input formControlName="driverPhone" /></div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="submit()">{{ 'COMMON.SAVE' | translate }}</button>
    </div>
  </div>
</div>
